import qweBaseField from "../BaseField"
import { ElMessage } from 'element-plus'
import { MethodsUrl } from  '../../../apis/index'
import { ResponseCode } from '../../../common/constant'
import { removeMedia } from '../../../apis/httpHelper'
import { qweIsEmpty,qweGuid } from "../../../common/commonHelper"

export default {
    mixins:[qweBaseField],
    data:function(){
        return {
            isMultiple: false,
            action: "",
            uploadData: ""
        };
    },

    created:function(){
        this.action = this.$store.state.baseUrl + MethodsUrl.uploadFile;
        this.uploadData = {
            "__RequestVerificationToken":this.$store.state.requestVerificationToken,
            contentType:this.contentType,
            fieldName:this.name
        };
        this.isMultiple = this.selfSetting.IsMultiple;
        if(!qweIsEmpty(this.data[this.name])){
            (this.data[this.name] || []).forEach(x=>{
                x.url = x.Url;
                x.name = x.Name;
                x.uuid = qweGuid();
            })
        }
    },

    computed:{
        disabledClass:function(){
            return this.disabled ? "disableUpload" : ""
        },

        valueString:function(){
            return JSON.stringify(this.data[this.name])
        }
    },

    methods:{
        onSuccess:function(response, file, files){
            let code = response.Code;
            if(code !== ResponseCode.Success){
                files.splice(files.indexOf(file), 1)
                response.ErrorMessages.forEach(element => {
                    setTimeout(() => {
                        ElMessage.error(element.ErrorMessage)
                    }, 50);
                });
            }
            else{
                let responseFile = response.Result[0];
                file.IsNew = true;
                file.url = responseFile.url;
                this.data[this.name] = this.data[this.name] || [];
                this.data[this.name].push({
                    IsNew: true,
                    uuid: file.uuid,
                    url:responseFile.url,
                    name: file.name,
                    Name: file.name,
                    Url: responseFile.url
                })
            }
        },

        onError:function(error){
            ElMessage.error("上传失败，请稍后再试，如遇多次问题请联系管理员");
            console.log(error);
        },

        beforeRemove:function(file){
            let that = this;
            if(this.disabled){
                return Promise.reject();
            }
            this.$confirm("确认删除当前图片？", "删除图片", {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                if(file.IsNew){
                    return removeMedia(file.url).then(x=>{
                        if(x.Result == true){
                            return Promise.resolve();
                        }
                        else{
                            return Promise.reject();
                        }
                    });
                }
                else{
                    return Promise.resolve();
                }
            }).catch(()=>{})
        }, 

        onPreview:function(file){
            window.open(file.url, "_blank");
        }
    }
}